import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { Order_Validation } from "../../utills/Validation";
import { cancelOrder } from "../../redux/action/order";
import { APIURL } from "../../redux/action/config";
import axios from "axios";
import { enableStaffStatus } from "../../redux/action/staff";
import { enableFleetStatus } from "../../redux/action/fleet";

const CancelOrder = ({modalId, id, data}) => {
    const dispatch = useDispatch();
    const [ordersDetails, setOrdersDetails] = useState();
    const [StaffID, setStaffID] = useState();
    const [FleetID, setFleetID] = useState();

    const getOrderDetails = (id) => {
      const token = localStorage.getItem("token");
  
      var config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
  
      axios
        .get(`${APIURL}/api/v1/order/${id}`, config)
        .then((response) => {
          setOrdersDetails(response.data.data.order);
          setStaffID(response.data.data.order.staffs_id.id);
          setFleetID(response.data.data.order.fleet_id.id);
        })
        .catch((error) => {
          console.log(error);
        });
    };
    useEffect(() => {
      if (id) {
        getOrderDetails(id);
      }
    }, [id, dispatch]);

    // console.log('test', data, ordersDetails)
    const resetForms = () => {
        document.getElementById("myForm").reset();
      };
    
    const sendMessage = (user, phone, orderno, message)=>{
      var myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        var raw = JSON.stringify({
          phone: phone,
          subject: 'Order Cancelled Successfully!',
          message: `
Hi ${user}, 

The status of your order no. ${orderno} has been marked as Cancelled. 
The reason for the same is as follow: 
${message}.

You can contact Roadside Reponse support for any further queries. 

Regards, 
Team Roadside Response.
`,
        });

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow',
        };

        fetch(`${APIURL}/api/v1/users/sendMessage`, requestOptions)
          .then(response => response.json())
          .then(result => console.log(result))
          .catch(error => console.log('error', error));
    }
  return (
    <React.Fragment>
    <ToastContainer autoClose={2000} />
      <div
        className="modal fade"
        id={modalId}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={()=>{
                    resetForms();
                }}
              ></button>
            </div>
            <div className="modal-body">
              <div className="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
                    <div className="mb-8 text-center">
                        <h1 className="mb-3 text-primary">Order Cancellation</h1>
                    </div>
                    <div className="separator d-flex flex-center mb-8"></div>
                    <Formik
                        initialValues={{
                        note: '',
                        }}
                        validationSchema={Order_Validation}
                        onSubmit={(values) => {
                            dispatch(cancelOrder(values.note, id, 'order_canceled'));
                            resetForms();
                            dispatch(enableStaffStatus(StaffID));
                            dispatch(enableFleetStatus(FleetID));
                            sendMessage(data?.customer_id?.firstName,data?.customer_id?.phone, data?.invoice_no, values.note )
                        }}
                    >
                        {({
                        values,
                        handleBlur,
                        handleChange,
                        handleSubmit,
                        errors,
                        resetForm,
                        touched,
                        }) => (
                            <form className="form" onSubmit={handleSubmit} id="myForm">
                            <div className="row row-cols-12 row-cols-sm-12 rol-cols-md-12 row-cols-lg-12">
                              <div className="col">
                                <div className="fv-row mb-7 fv-plugins-icon-container">
                                  <label className="fs-6 fw-bold form-label mt-3">
                                    <span className="required">Message</span>
                                  </label>
                                  {/* <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="name"
                                    id="name"
                                    defaultValue={values.name}
                                  /> */}
                                  {
                                    data?.cancel_note && data?.cancel_note?.length > 0 ? 
                                    <textarea
                                        rows="5"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        name="note"
                                        id="note"
                                        className="form-control form-control-solid"
                                        value={data?.cancel_note}
                                        disabled
                                    ></textarea> : 
                                    <textarea
                                        rows="5"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        name="note"
                                        id="note"
                                        className="form-control form-control-solid"
                                        value={values?.note?.length ? values.note : ''}
                                    ></textarea>
                                  }
                                  {errors.note && touched.note ? (
                                    <div className="text-danger mt-2">
                                      {errors.note}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                            {
                                data?.cancel_note && data?.cancel_note?.length > 0 ? 
                                ''
                             : 
                             <div className="row">
                                <div className="col d-flex justify-content-center align-items-center">
                                    <button type="button" className="btn btn-secondary me-2"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        onClick={()=>{
                                            resetForms();
                                            resetForm()
                                        }}
                                        style={{ color: 'black' }}
                                    >
                                    Cancel
                                    </button>
                                    <button type="submit" className="btn btn-primary">
                                    <span className="indicator-label">Save</span>
                                    </button>
                                </div>
                            </div>
                            }
                            
                          </form>
                          
                        )}
                    </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CancelOrder;
